import { Link, useParams } from "react-router";
import { GradeDoPainel } from "../componentes/paineis/GradeDoPainel";
import { Aviso } from "../componentes/ui";
import { mensagemDoConsole } from "../nucleo/console";
import { usePainelParaVer } from "../nucleo/paineis";
import { useTitulo } from "../nucleo/titulo";

/** Um painel como quem o abre pode vê-lo: a administração confere aqui o que montou. */
export function VerPainel() {
  const { id = "" } = useParams();
  useTitulo("Painel");
  const painel = usePainelParaVer(id);

  if (painel.isPending) return <p role="status">Carregando painel…</p>;
  if (painel.isError) return <Aviso tom="erro">{mensagemDoConsole(painel.error)}</Aviso>;

  return (
    <>
      <p className="nota-rodape">
        <Link to="/admin/paineis">Painéis da equipe</Link>
      </p>
      <h1 className="titulo-pagina">{painel.data.nome}</h1>
      {painel.data.descricao ? <p className="lead">{painel.data.descricao}</p> : null}
      <GradeDoPainel painel={painel.data} />
    </>
  );
}
